export default __webpack_public_path__ + "static/media/QRcodeMobileApp.1320c597.svg";